// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__2uHLw","inputDescription":"styles_inputDescription__1yTfb"};